<template>
<section>
<div>
<modal class="lg para-font" scroll v-if="showConfirmation" @close="showConfirmation = false">   
          <h3 slot="header">{{$t('entry.confirmText')}}
          </h3>
            <hr>
          <div slot="body">
                <p class="para height alert alert-info">
          {{instructions.startUpPara}} 
      </p>
            <p class="p-bot">
          {{$t('candidateProfile.agreement.lblUndertakes')}}
      </p>
            <ul class="para-font">
              <li v-for="item in instructions.instructionList">{{item.instructionMsg}}
                <ul class="subInstructionFont" v-if="item.subInstructions">
                  <li v-for="subItem in item.subInstructions">{{subItem.instructionMsg}} </li>
                </ul>
              </li>
            </ul>
            <label class="c-wrap para-font ml-4">
              <input type="checkbox" v-model="checkedTermCondition" :value=true id="checkedTermCondition">
              <span class="checkmark"></span>&nbsp;
              <strong><sup><i class="mdi mdi-star text-danger"> </i></sup> 
                {{$t('entry.lblcheckedTermCondition')}}
              </strong>
            </label>
           </div>
           <div slot="footer">
            <button type="button" :disabled="!checkedTermCondition" class="btn btn btn-success-alt mr-3" @click="saveTermCondition"> {{$t('button.confirm')}}</button>             
           <p></p>
           </div>
    </modal>
</div>
</section>
</template>
<script>
import axios from 'axios'
import modal from '@/components/common/modal.vue'
axios.default.baseURL = ''
export default {
  name: 'Entry',
  components: {modal},
  data () {
    return {
      universityConfig: {},
      isApplicationCompleted: false,
      showConfirmation: false,
      checkedTermCondition: false,
      instructions: {}
    }
  },
  methods: {
    fetchUserDetails: function () {
      var self = this
      axios.get('/r/entry/getUserApplicationStatus/' + self.$store.state.candidateProfile.profileUser).then(response => {
        if (response.data !== null) {
          self.isApplicationCompleted = response.data.appStatus
          let profileStatus = response.data.profileStatus
          let confStatus = response.data.confStatus
          if (profileStatus.termConditionDetails) {
            if (confStatus) {
              self.$store.commit('STORE_CONFIRM_STATUS', true)
            }
            if (self.isApplicationCompleted === true) {
              // replace below line with redirection
              window.MKCLAPI.switchAppWithSingleSignOn(self.MFS_CLIENT_ID)
            } else {
              if (confStatus) {
                self.$router.push({ name: 'candidateApplication' })
              } else if (!profileStatus.itCertificationsDetails) {
                self.$router.push({ name: 'agreement' })
              } else if (!profileStatus.personalDetails) {
                self.$router.push({ name: 'personalDetails' })
              } else if (!profileStatus.contactDetails) {
                self.$router.push({ name: 'address' })
              } else if (!profileStatus.educationDetails) {
                self.$router.push({ name: 'educationalDetails' })
              } else if (!profileStatus.documentDetails) {
                self.$router.push({ name: 'documentsupload' })
              } else if (!profileStatus.qualificationDetails) {
                axios.get('r/projectConfig/getAllProjectConfig')
                .then(responses => {
                  if (responses.data.ocrConfig.required) {
                    self.$router.push({ name: 'imageExtracter' })
                  } else {
                    self.$router.push({ name: 'qualificationDetails' })
                  }
                })
                .catch(e => {
                  console.log(e)
                })
              } else if (profileStatus.qualificationDetails) {
                self.$router.push({ name: 'profileSummary' })
              } else {
                self.$router.push({ name: 'agreement' })
              }
            }
          } else {
            this.getTermCondition()
          }
        }
      }).catch(function (e) {
        console.error(e)
      })
    },
    saveTermCondition () {
      axios.post('r/candidateProfile/saveTermConditionStatus/' + this.$store.state.candidateProfile.profileUser)
      .then(response => {
        if (response.data) {
          this.showConfirmation = false
          this.$toasted.success(this.$t('toastr.toastrTermConditionSaved'))
          this.fetchUserDetails()
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    getTermCondition () {
      axios.get('r/getGeneralInstructions/' + 'TermCondition')
      .then(responses => {
        if (responses.status === 200) {
          this.instructions = responses.data
          this.showConfirmation = true
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    getProjectConfig () {
      axios.get('o/projectConfig/getUniversityConfig').then(response => {
        this.universityConfig = response.data
      }).catch(function (e) {
        console.error(e)
      })
    }
  },
  created: function () {
    var token = window.MKCLAPI.getDecodedToken()
    this.$store.commit('STORE_PROFILE_USER', token.username)
  },
  mounted: function () {
    this.fetchUserDetails()
    this.getProjectConfig()
  }
}
</script>
<style lang="scss">
  .para-font{
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/entry/entry.vue